import { getTesterPermissionsFromStorage } from "./testerPermissions";

/**
 * Admin RBAC permission names from localStorage (set on login + synced in AdminLayout).
 * Testers operate inside the admin panel but their permissions are stored under
 * "tester-permissions"; fall back to that so admin pages gating on adminHasPermission()
 * work for the tester role (matches RequireAdminPermission in routes.js).
 */
export function getAdminPermissionsFromStorage() {
  try {
    if (localStorage.getItem("role") === "tester") {
      return getTesterPermissionsFromStorage() ?? [];
    }
    const raw = localStorage.getItem("admin-permissions");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function adminHasPermission(permission) {
  if (!permission || typeof permission !== "string") return false;
  return getAdminPermissionsFromStorage().includes(permission);
}

/** True if the user has every listed permission */
export function adminHasAllPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.every((p) => adminHasPermission(p));
}

/** True if the user has at least one of the listed permissions */
export function adminHasAnyPermission(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((p) => adminHasPermission(p));
}
